export default "__VITE_ASSET__49797d38__"